import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import { isDisabled, isSubmitting } from './formUtils'
import LoadingButton from '@carsys/ui/src/LoadingButton'
import { LoadingButtonProps } from '@mui/lab'
import SaveIcon from '@mui/icons-material/Save'

interface SubmitButtonProps extends LoadingButtonProps {
  children: string
}

export function SubmitButton({ children, ...props }: SubmitButtonProps) {
  const formik = useFormikContext<any>()
  const { t, i18n } = useTranslation()

  const content = i18n.exists(children) ? t(children) : children

  return (
    <LoadingButton
      loading={isSubmitting(formik)}
      startIcon={<SaveIcon />}
      disabled={isDisabled(formik)}
      data-testid='btn-submit'
      {...props}
    >
      {content}
    </LoadingButton>
  )
}

SubmitButton.defaultProps = {
  children: 'Form.Buttons.Submit',
  color: 'primary',
  type: 'submit',
  variant: 'contained'
}
